import script from "./PopoverModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PopoverModal.vue?vue&type=script&setup=true&lang=js"

import "./PopoverModal.vue?vue&type=style&index=0&id=a9615eb2&lang=scss"

const __exports__ = script;

export default __exports__